
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class CalendarCard extends Vue {
  @Prop() dataSource: {
    y: number
    m: number
    d: number
    timestamp: number
    isActiveDay: number
    isCurrentDay: number
    isExistClasshour: boolean
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
